import { FC, MouseEventHandler } from "react";
import { useSelector } from "react-redux";

import { Info } from "@livechat/design-system-icons";
import { Button, Icon } from "@livechat/design-system-react-components";

import { EmptyState } from "components/empty-state/EmptyState";
import Flex from "components/layout/Flex";
import { selectIsAdmin } from "store/entities/agents";

interface IProps {
  onClick: MouseEventHandler;
}

export const ContactFormsEmptyState: FC<IProps> = ({ onClick }) => {
  const isAdmin = useSelector(selectIsAdmin);

  return (
    <Flex margin="0 auto" column alignItems="center" maxWidth="370px">
      <EmptyState
        title="No contact forms yet"
        icon={<Icon source={Info} size="xxxlarge" />}
        actions={
          <Button onClick={onClick} kind="secondary" data-testid="create-contact-form-empty" disabled={!isAdmin}>
            Create contact form
          </Button>
        }
      >
        Create your first contact form so website visitors can send messages straight to you.
      </EmptyState>
    </Flex>
  );
};
